/*
 * Part of the RubinRed CMS.
 * @author    Marco Tisi <tisi@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.com
 */

import UIkit from 'js/components'

export default UIkit;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/vendor/uikit.js